module.exports = __webpack_public_path__ + "static/media/DSC_2736.e56dcc00.jpg";